export class EvoModel {

	deserialize(input: any): this {
		Object.assign(this, input);
		return this;
	}

}
